import { apiInstance } from "../utils/_apiInstance";

export const deleteSavedDocument = async (documentId: string) => {
  const response = await apiInstance.delete<{ message: string }>(
    `/documentos/${documentId}`,
  );
  return response.data;
};
